import React, { useState, useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './IskonVrat.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';

import city from '../../../city.json'



import axios from 'axios';



const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};




const ekadashiImageMap = {
  'Putrada Ekadashi': 'https://www.iskconbangalore.org/blog/wp-content/uploads/2020/02/putrada-ekadashi.jpg',
  'Bhaimi Ekadashi': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSfhVU6mm0adzbbyGRk1a0jGgCSc_PfxGSgzQ&s',
  'Papamochani Ekadashi': 'https://files.prokerala.com/images/1200/papamochani-ekadashi.jpg',
  'Mohini Ekadashi': 'https://wd-image.webdunia.com/image-conversion/process-aws.php?url=https://nonprod-media.webdunia.com/public_html/_media/hi/img/article/2024-05/08/full/1715167142-0257.jpg&w=&h=&outtype=webp',
  'Sayana Ekadashi': 'https://iskconbangalore.co.in/sites/default/files/2024-07/Sayana-Ekadasi.jpg',
  'Pavitropana Ekadashi': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS94rg6A9XjpNsKPq8jv3Zntgoiy68lHWKaJQ&s',
  'Utthana Ekadashi': 'https://iskcondwarka.org/wp-content/uploads/2022/11/EXTERNAL-Utthana-Ekadashi.jpg',
  'Shukla Ekadashi': 'https://bsmedia.business-standard.com/_media/bs/img/article/2024-07/17/thumb/fitandfill/1200X900/1721205348-655.jpg',
};








const IskonVrat = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12');

  const [vratList, setVratList] = useState([]);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSankasthi, setSelectedSankasthi] = useState(null);


  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  const ekadashiTooltips = {
  "Putrada Ekadashi": "Putrada Ekadashi is observed for the well-being and longevity of children. Devotees fast and offer prayers to Lord Vishnu, seeking blessings for progeny and happiness in family life.",
  "Bhaimi Ekadashi": "Bhaimi Ekadashi, also known as Jaya Ekadashi, is believed to absolve one of sins and help attain liberation. Observing fast and reciting Vishnu Sahasranama are common practices.",
  "Papamochani Ekadashi": "Papamochani Ekadashi is known for washing away past sins and bringing spiritual upliftment. It falls between Holika Dahan and Chaitra Navratri.",
  "Mohini Ekadashi": "Mohini Ekadashi commemorates the incarnation of Lord Vishnu as Mohini. It is believed to destroy sins and grant salvation to the observer.",
  "Sayana Ekadashi": "Sayana Ekadashi marks the start of Lord Vishnu's cosmic slumber (Chaturmas). Devotees fast and worship Vishnu to receive divine blessings during this sacred period.",
  "Pavitropana Ekadashi": "Pavitropana Ekadashi is observed to cleanse the mind and soul. Tying a sacred thread (raksha sutra) and offering tulsi leaves to Lord Vishnu are part of the rituals.",
  "Utthana Ekadashi": "Utthana Ekadashi, also called Devutthana Ekadashi, signifies Lord Vishnu’s awakening from his divine sleep. It marks the end of Chaturmas and is considered very auspicious for marriages.",
  "Shukla Ekadashi": "Shukla Ekadashi generally refers to Ekadashi falling during the waxing moon (Shukla Paksha). It is a sacred fasting day devoted to Lord Vishnu for peace and prosperity."
};


useEffect(() => {
  const fetchvratData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/Iskon-ekadashi?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.ekadashiDates) {
        setVratList(response.data.ekadashiDates);
      } else {
        setVratList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch iskon ekadashi data:", error);
      setVratList([]);
    }
  };

  fetchvratData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });


    const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };


  return (
    <div className="IskonVrat-container">
      <InnerNav />
      <div className="IskonVrat-content">
        <Zodiac />

        {/* Ekadashi Calendar JSX starts here */}
        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Ekadashi Dates</h2>
              <div className="current-ekadashi">
                <img src="https://www.drikpanchang.com/images/gods/dashavatara/lord-vishnu/goddess-ekadashi/xgoddess_ekadashi.jpg.pagespeed.ic.dfbOvswP8y.jpg" alt="Moon" className="moon-preview" />
                <div>
                 
                  <p>{location}</p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="I-controls">
               <div className="location-date">
                  <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>

{!selectedSankasthi ? (
  <div className="isvrat-list">
    {vratList.length === 0 && (
      <p>No Iskon Ekadashi data available for selected year/location.</p>
    )}

    {vratList.map((item, idx) => (
      <div
        className="isvrat-item clickable"
        key={idx}
        onClick={() => setSelectedSankasthi(item)}
      >
        <img
          src={ekadashiImageMap[item.title] || "https://www.drikpanchang.com/images/gods/dashavatara/lord-vishnu/goddess-ekadashi/xgoddess_ekadashi.jpg.pagespeed.ic.dfbOvswP8y.jpg"}
          alt={item.title}
        />

        <div className="isvrat-details">
          <p className="isvrat-date">{item.date}</p>

          <div className="isvrat-name">{item.title}</div>

          <p className="isvrat-phase">{item.parana}</p>
          <p className="isvrat-tithi">{item.tithiName}</p>
          <p className="isvrat-tithi">{item.masa}</p>
        </div>

        <div className="isvrat-timings">
          <p>{item.ekadashiType}</p>
          <p>{formatTime(item.tithiStart, timeFormat)}</p>
          <p>{formatTime(item.tithiEnd, timeFormat)}</p>
          <p>{item.duration}</p>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="san-detail-view">
    <button
      className="back-btn"
      onClick={() => setSelectedSankasthi(null)}
    >
      ← Back
    </button>

    <h2>{selectedSankasthi.title}</h2>

    <img
      src={
        ekadashiImageMap[selectedSankasthi.title] ||
        "https://www.drikpanchang.com/images/gods/dashavatara/lord-vishnu/goddess-ekadashi/xgoddess_ekadashi.jpg"
      }
      alt={selectedSankasthi.title}
    />

    {/* BASIC META */}
    <div className="detail-grid">
      <div><strong>Date:</strong> {selectedSankasthi.date}</div>
      <div><strong>Location:</strong> {location}</div>
      <div><strong>Year:</strong> {year}</div>
      <div><strong>Masa:</strong> {selectedSankasthi.masa}</div>
    </div>

    {/* EKADASHI DETAILS */}
    <div className="detail-grid">
      <div><strong>Ekadashi Type:</strong> {selectedSankasthi.ekadashiType}</div>
      {/* <div><strong>Tithi:</strong> {selectedSankasthi.tithiName}</div> */}
      <div><strong>Parana:</strong> {selectedSankasthi.parana}</div>
      <div><strong>Duration:</strong> {selectedSankasthi.duration}</div>
    </div>

    {/* TITHI TIMINGS */}
    <div className="detail-section">
      <h3>Tithi Timings</h3>
      <p>
        <strong>Start:</strong>{" "}
        {formatTime(selectedSankasthi.tithiStart, timeFormat)}
      </p>
      <p>
        <strong>End:</strong>{" "}
        {formatTime(selectedSankasthi.tithiEnd, timeFormat)}
      </p>
    </div>

    {/* SIGNIFICANCE */}
    {ekadashiTooltips[selectedSankasthi.title] && (
      <div className="detail-section">
        <h3>Significance</h3>
        <p>{ekadashiTooltips[selectedSankasthi.title]}</p>
      </div>
    )}
  </div>
)
}

        </div>
        {/* Ekadashi Calendar JSX ends here */}

            <section className="iskcon-wrapper">
      <h1 className="iskcon-title">ISKCON Ekadashi</h1>
      <div className="iskcon-texts">
        <p>
          Ekadashi fasting is observed on every 11th Tithi in Hindu calendar. There are two Ekadashi fasting in a month, one during Gaura Paksha and another during Krishna Paksha. Devotees of Lord Vishnu observe Ekadashi fasting to seek His blessings.
        </p>
        <p>
          Ekadashi fasting spans for three days. Devotees take single meal in the afternoon a day before fasting day to make sure there is no residual food in the stomach on next day. Devotees keep strict fast on Ekadashi day and break the fast on next day only after sunrise. Eating of all type of grains and cereals is prohibited during Ekadashi fasting.
        </p>
        <p>
          Devotees can choose to observe fasting without water, with only water, with only fruits, or with one time latex food according to their will and body power. However, it should be decided before starting the fast.
        </p>
        <p>
          The Ekadashi list for ISKCON follows the same Ekadashi and Parana (time to break fast) rules as traditionally followed in Vaisnava Sampradaya. These dates are meant specifically for followers of ISKCON. Devotees from other Sampradayas should refer to their respective Ekadashi lists.
        </p>
      </div>
    </section>
            <VratLinks/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default IskonVrat;
